import React, { Component } from "react";
import classnames from "classnames";

import ProductStyles from "components/glamclub/ProductDetails.module.scss";
import { StarRating } from "./StarRating";
import { Modal } from "components/modal/Modal";
import { ProductReviewForm } from "./ProductReviewForm";

export class ProductComments extends Component {
  constructor (props) {
    super(props);

    this.state = {
      commentModalVisible: false
    };
    
    this.renderComments = this.renderComments.bind(this);
    this.toggleCommentModal = this.toggleCommentModal.bind(this);
  }

  toggleCommentModal () {
    this.setState({
      commentModalVisible: !this.state.commentModalVisible
    }, () => {
      if (this.props.onReviewSuccess) this.props.onReviewSuccess();
    });

    this.forceUpdate();
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (nextProps.comments !== this.props.comments) return true;
    return false;
  }

  renderComments () {
    let { comments } = this.props;
    
    if (Array.isArray(comments) && comments.length > 0) {
      return comments.map((item, key) => {
        let commentDate = new Date(item.dateCreated);

        return (
          <div key={key} className={ProductStyles["comments__item"]}>
            <div className={ProductStyles["comments__item-name"]}>
              <h6 className={"m-0"}>
                {item.nickname}
              </h6>
              <p>
                <small>{commentDate.toLocaleDateString("pt-BR")}</small>
              </p>
              <StarRating rating={item.rating} className={ProductStyles["comments__item-rating"]}/>
            </div>
            <div className={ProductStyles["comments__item-text"]}>
              <h5>{item.reviewTitle}</h5>
              <p>{item.review}</p>
            </div>
          </div>
        );
      });
    }

    return (
      <div className={ProductStyles["comments__none"]}>
        <p>Nenhuma avaliação foi feita para este produto.</p>
      </div>
    );
  }

  render () {
    return (
      <div className={classnames(ProductStyles["comments"], "level-2")}>
        <div className={ProductStyles["comments__header"]}>
          <div className={classnames(ProductStyles["comments__header-title"], "text-center", "text-lg-left")}>
            <h3 className={"display-3 m-0"}>Avaliação Geral</h3>
            <p>
               {this.props.comments.length} comentários de clientes
            </p>
          </div>
          <div className={classnames(ProductStyles["comments__header-stars"], "text-center", "text-lg-left")}>
            <StarRating rating={this.props.rating} className={ProductStyles["comments__header-rating"]}/>
            <p>{this.props.rating.toFixed(2)} de 5 estrelas</p>
          </div>
          <div className={ProductStyles["comments__header-action"]}>
            <button className={"btn btn-light-lime btn-sm"} onClick={this.toggleCommentModal}>
              Comentar
            </button>

            <Modal visible={this.state.commentModalVisible} onCloseModal={this.toggleCommentModal}>
              <ProductReviewForm productId={this.props.productId} onFinishSubmit={this.toggleCommentModal}/>
            </Modal>
          </div>
        </div>
        <div className={ProductStyles["comments__list"]}>
          {this.renderComments()}
        </div>
      </div>
    );
  }
}
